import Page from '@shell/Page'
import VideoTemplate from '@order/steps/templates/Video'

export default function DevStepsPage() {
  return (
    <Page stage="dev">
      <VideoTemplate
        title="Packages"
        desc="Which level of visual comfort would you like?\nSelect Standard, Premium, High-End or World-Class Progressive Glasses!"
        options={[
          {
            id: '1',
            image: require('@/images/packages/standard.png'),
            title: 'Standard Gleitsichtbrille',
            desc: 'Vision in the budget range.',
            colorOption: 'gray',
            pricePrefix: 'only',
            price: {
              base: 59,
            },
            stepVariable: 'package',
          },
          {
            id: '2',
            image: require('@/images/packages/premium.png'),
            title: 'Premium Gleitsichtbrille',
            desc: 'Including wider viewing areas.',
            colorOption: 'green',
            pricePrefix: 'from',
            price: {
              base: 249,
            },
            stepVariable: 'package',
            label: 'Bestseller',
          },
          {
            id: '3',
            image: require('@/images/packages/high-end.png'),
            title: 'High-End Gleitsichtbrille',
            desc: 'Higher level of visual comfort.',
            colorOption: 'magenta',
            pricePrefix: 'only',
            price: {
              base: 279,
            },
            stepVariable: 'package',
            label: 'Best Savings',
          },
          {
            id: '5',
            image: require('@/images/packages/steiner.png'),
            title: 'World-Class Gleitsichtbrille',
            desc: 'The best eyewear equipment possible!',
            colorOption: 'blue',
            pricePrefix: 'from',
            price: {
              base: 699,
            },
            stepVariable: 'package',
            label: 'Full Equipment',
            recommended: true,
          },
        ]}
      />
    </Page>
  )
}
